import Ajv from "ajv";

// Performance shim for @rjsf/core 4.x.
//
// rjsf's isValid() (used to pick the matching oneOf branch of every schema
// dependency) does, on every call:
//     ajv.addSchema(rootSchema, "__rjsf_rootSchema").validate(...)
//     ajv.removeSchema("__rjsf_rootSchema")
// addSchema meta-validates and serializes the *whole* root schema each time.
// Our KYC schemas are ~0.5 MB with nested oneOf dependencies, so every change
// in a form froze the page for many seconds.
//
// Here we keep the root schema registered while the same schema object is
// passed again, and only swap it when rjsf passes a different root schema.
// Every other addSchema/removeSchema call goes to ajv unchanged.

const ROOT_SCHEMA_KEY = "__rjsf_rootSchema";
const { addSchema, removeSchema } = Ajv.prototype;
const registeredRoot = new WeakMap(); // ajv instance -> root schema object

if (!Ajv.prototype.__rjsfRootSchemaCache) {
    Ajv.prototype.__rjsfRootSchemaCache = true;

    Ajv.prototype.addSchema = function (schema, key, ...rest) {
        if (key !== ROOT_SCHEMA_KEY) return addSchema.call(this, schema, key, ...rest);
        if (registeredRoot.get(this) === schema) return this;
        if (registeredRoot.has(this)) {
            removeSchema.call(this, ROOT_SCHEMA_KEY);
            registeredRoot.delete(this);
        }
        addSchema.call(this, schema, key, ...rest);
        registeredRoot.set(this, schema);
        return this;
    };

    Ajv.prototype.removeSchema = function (ref) {
        // Keep the cached root schema; it gets swapped in addSchema when it changes.
        if (ref === ROOT_SCHEMA_KEY && registeredRoot.has(this)) return this;
        return removeSchema.call(this, ref);
    };
}
